const MARKET_TOASTER = `market-toaster`;
const MARKET_TOAST = `market-toast`;

export type Toast = {
  message: string;
  persistent?: boolean;
  variant: HTMLMarketToastElement['variant'];
};

// Create a `MarketToaster` in case it doesn't exist. Return
// `MarketToaster` to be used used as container for `MarketToast`
const createOrReturnToaster = (): HTMLMarketToasterElement => {
  const toaster: HTMLMarketToasterElement | null =
    document.querySelector(MARKET_TOASTER);

  if (!toaster) {
    const toaster = document.createElement(MARKET_TOASTER);
    document.body.appendChild(toaster);

    return toaster as HTMLMarketToasterElement;
  }

  return toaster;
};

const showToast = ({ message, persistent, variant }: Toast) => {
  const toaster = createOrReturnToaster();

  const newToast = document.createElement(MARKET_TOAST);
  newToast.variant = variant;
  newToast.innerText = message;
  newToast.persistent = persistent || false;

  toaster?.show(newToast);
};

export const useToast = () => {
  return [showToast];
};
